module.exports = __webpack_public_path__ + "static/media/archive-start@2x.74f9fcb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/archive-start@2x.png
// module id = 928
// module chunks = 0